module.exports = __webpack_public_path__ + "img/calendar2-day-fill.94bd2a65.svg";